var map = {
	"./components/FormBuilder/lang/en.json": 1318,
	"./components/FormBuilder/lang/fa.json": 1319,
	"./components/classes/Assignment/lang/en.json": 1320,
	"./components/classes/Assignment/lang/fa.json": 1321,
	"./components/classes/Position/lang/en.json": 1322,
	"./components/classes/Position/lang/fa.json": 1323,
	"./components/classes/User/lang/en.json": 1324,
	"./components/classes/User/lang/fa.json": 1325,
	"./components/common/Charts/lang/en.json": 1326,
	"./components/common/Charts/lang/fa.json": 1327,
	"./components/common/Cropper/lang/en.json": 1328,
	"./components/common/Cropper/lang/fa.json": 1329,
	"./components/common/Notification/lang/en.json": 1330,
	"./components/common/Notification/lang/fa.json": 1331,
	"./components/common/Print/lang/en.json": 1332,
	"./components/common/Print/lang/fa.json": 1333,
	"./components/common/ReportPrint/lang/en.json": 1334,
	"./components/common/ReportPrint/lang/fa.json": 1335,
	"./components/common/StateDiagram/lang/en.json": 1336,
	"./components/common/StateDiagram/lang/fa.json": 1337,
	"./components/common/Table/lang/en.json": 1338,
	"./components/common/Table/lang/fa.json": 1339,
	"./routes/Auth/lang/en.json": 1340,
	"./routes/Auth/lang/fa.json": 1341,
	"./routes/General/lang/en.json": 1342,
	"./routes/General/lang/fa.json": 1343,
	"./routes/Home/ActivityLog/lang/en.json": 1344,
	"./routes/Home/ActivityLog/lang/fa.json": 1345,
	"./routes/Home/Attendance/Calendar/lang/en.json": 1346,
	"./routes/Home/Attendance/Calendar/lang/fa.json": 1347,
	"./routes/Home/Attendance/Clocking/lang/en.json": 1348,
	"./routes/Home/Attendance/Clocking/lang/fa.json": 1349,
	"./routes/Home/Attendance/Device/lang/en.json": 1350,
	"./routes/Home/Attendance/Device/lang/fa.json": 1351,
	"./routes/Home/Attendance/Diagrams/lang/en.json": 1352,
	"./routes/Home/Attendance/Diagrams/lang/fa.json": 1353,
	"./routes/Home/Attendance/Forgiveness/lang/en.json": 1354,
	"./routes/Home/Attendance/Forgiveness/lang/fa.json": 1355,
	"./routes/Home/Attendance/Leave/lang/en.json": 1356,
	"./routes/Home/Attendance/Leave/lang/fa.json": 1357,
	"./routes/Home/Attendance/ManagerOpinion/lang/en.json": 1358,
	"./routes/Home/Attendance/ManagerOpinion/lang/fa.json": 1359,
	"./routes/Home/Attendance/Modifier/lang/en.json": 1360,
	"./routes/Home/Attendance/Modifier/lang/fa.json": 1361,
	"./routes/Home/Attendance/Policy/Definition/lang/en.json": 1362,
	"./routes/Home/Attendance/Policy/Definition/lang/fa.json": 1363,
	"./routes/Home/Attendance/Policy/lang/en.json": 1364,
	"./routes/Home/Attendance/Policy/lang/fa.json": 1365,
	"./routes/Home/Attendance/Reports/lang/en.json": 1366,
	"./routes/Home/Attendance/Reports/lang/fa.json": 1367,
	"./routes/Home/Attendance/Rules/lang/en.json": 1368,
	"./routes/Home/Attendance/Rules/lang/fa.json": 1369,
	"./routes/Home/Attendance/Salary/FactorSalary/lang/en.json": 1370,
	"./routes/Home/Attendance/Salary/FactorSalary/lang/fa.json": 1371,
	"./routes/Home/Attendance/Salary/Modifier/lang/en.json": 1372,
	"./routes/Home/Attendance/Salary/Modifier/lang/fa.json": 1373,
	"./routes/Home/Attendance/Salary/RulePack/lang/en.json": 1374,
	"./routes/Home/Attendance/Salary/RulePack/lang/fa.json": 1375,
	"./routes/Home/Attendance/Salary/SalaryFish/Modifier/lang/en.json": 1376,
	"./routes/Home/Attendance/Salary/SalaryFish/Modifier/lang/fa.json": 1377,
	"./routes/Home/Attendance/Salary/SalaryFish/lang/en.json": 1378,
	"./routes/Home/Attendance/Salary/SalaryFish/lang/fa.json": 1379,
	"./routes/Home/Attendance/Salary/SalaryItems/lang/en.json": 1380,
	"./routes/Home/Attendance/Salary/SalaryItems/lang/fa.json": 1381,
	"./routes/Home/Attendance/Salary/WritsSalary/lang/en.json": 1382,
	"./routes/Home/Attendance/Salary/WritsSalary/lang/fa.json": 1383,
	"./routes/Home/Attendance/Setting/lang/en.json": 1384,
	"./routes/Home/Attendance/Setting/lang/fa.json": 1385,
	"./routes/Home/Attendance/SettingAttendance/Patterns/Definition/lang/en.json": 1386,
	"./routes/Home/Attendance/SettingAttendance/Patterns/Definition/lang/fa.json": 1387,
	"./routes/Home/Attendance/SettingAttendance/Patterns/RulePack/lang/en.json": 1388,
	"./routes/Home/Attendance/SettingAttendance/Patterns/RulePack/lang/fa.json": 1389,
	"./routes/Home/Attendance/SettingAttendance/Sms/Definition/lang/en.json": 1390,
	"./routes/Home/Attendance/SettingAttendance/Sms/Definition/lang/fa.json": 1391,
	"./routes/Home/Attendance/SettingAttendance/lang/en.json": 1392,
	"./routes/Home/Attendance/SettingAttendance/lang/fa.json": 1393,
	"./routes/Home/Attendance/Shift/lang/en.json": 1394,
	"./routes/Home/Attendance/Shift/lang/fa.json": 1395,
	"./routes/Home/Attendance/Stack/Packs/lang/en.json": 1396,
	"./routes/Home/Attendance/Stack/Packs/lang/fa.json": 1397,
	"./routes/Home/Attendance/Stack/lang/en.json": 1398,
	"./routes/Home/Attendance/Stack/lang/fa.json": 1399,
	"./routes/Home/Attendance/WorkingHours/lang/en.json": 1400,
	"./routes/Home/Attendance/WorkingHours/lang/fa.json": 1401,
	"./routes/Home/Attendance/Writs/lang/en.json": 1402,
	"./routes/Home/Attendance/Writs/lang/fa.json": 1403,
	"./routes/Home/Basic/OrganizationChart/lang/en.json": 1404,
	"./routes/Home/Basic/OrganizationChart/lang/fa.json": 1405,
	"./routes/Home/Basic/Permission/lang/en.json": 1406,
	"./routes/Home/Basic/Permission/lang/fa.json": 1407,
	"./routes/Home/Basic/Personnel/lang/en.json": 1408,
	"./routes/Home/Basic/Personnel/lang/fa.json": 1409,
	"./routes/Home/Basic/lang/en.json": 1410,
	"./routes/Home/Basic/lang/fa.json": 1411,
	"./routes/Home/Bulletin/lang/en.json": 1412,
	"./routes/Home/Bulletin/lang/fa.json": 1413,
	"./routes/Home/CompanySetting/lang/en.json": 1414,
	"./routes/Home/CompanySetting/lang/fa.json": 1415,
	"./routes/Home/Dashboard/lang/en.json": 1416,
	"./routes/Home/Dashboard/lang/fa.json": 1417,
	"./routes/Home/Evaluation360/Report/lang/en.json": 1418,
	"./routes/Home/Evaluation360/Report/lang/fa.json": 1419,
	"./routes/Home/Evaluation360/lang/en.json": 1420,
	"./routes/Home/Evaluation360/lang/fa.json": 1421,
	"./routes/Home/Feed/Device/lang/en.json": 1422,
	"./routes/Home/Feed/Device/lang/fa.json": 1423,
	"./routes/Home/Feed/Report/lang/en.json": 1424,
	"./routes/Home/Feed/Report/lang/fa.json": 1425,
	"./routes/Home/Feed/Writs/lang/en.json": 1426,
	"./routes/Home/Feed/Writs/lang/fa.json": 1427,
	"./routes/Home/Feed/lang/en.json": 1428,
	"./routes/Home/Feed/lang/fa.json": 1429,
	"./routes/Home/Guardian/lang/en.json": 1430,
	"./routes/Home/Guardian/lang/fa.json": 1431,
	"./routes/Home/ManagementDecisions/lang/en.json": 1432,
	"./routes/Home/ManagementDecisions/lang/fa.json": 1433,
	"./routes/Home/Map/lang/en.json": 1434,
	"./routes/Home/Map/lang/fa.json": 1435,
	"./routes/Home/Notices/lang/en.json": 1436,
	"./routes/Home/Notices/lang/fa.json": 1437,
	"./routes/Home/Payroll copy/lang/en.json": 1438,
	"./routes/Home/Payroll copy/lang/fa.json": 1439,
	"./routes/Home/Payroll/lang/en.json": 1440,
	"./routes/Home/Payroll/lang/fa.json": 1441,
	"./routes/Home/Poll/lang/en.json": 1442,
	"./routes/Home/Poll/lang/fa.json": 1443,
	"./routes/Home/Profile/lang/en.json": 1444,
	"./routes/Home/Profile/lang/fa.json": 1445,
	"./routes/Home/Requests/Pattern/RulePack/lang/en.json": 1446,
	"./routes/Home/Requests/Pattern/RulePack/lang/fa.json": 1447,
	"./routes/Home/Requests/Procedure/lang/en.json": 1448,
	"./routes/Home/Requests/Procedure/lang/fa.json": 1449,
	"./routes/Home/Requests/Status/lang/en.json": 1450,
	"./routes/Home/Requests/Status/lang/fa.json": 1451,
	"./routes/Home/Requests/lang/en.json": 1452,
	"./routes/Home/Requests/lang/fa.json": 1453,
	"./routes/Home/Salary/FactorSalary/lang/en.json": 1454,
	"./routes/Home/Salary/FactorSalary/lang/fa.json": 1455,
	"./routes/Home/Salary/Modifier/lang/en.json": 1456,
	"./routes/Home/Salary/Modifier/lang/fa.json": 1457,
	"./routes/Home/Salary/SalaryFish/Modifier/lang/en.json": 1458,
	"./routes/Home/Salary/SalaryFish/Modifier/lang/fa.json": 1459,
	"./routes/Home/Salary/SalaryFish/lang/en.json": 1460,
	"./routes/Home/Salary/SalaryFish/lang/fa.json": 1461,
	"./routes/Home/Salary/SalaryItems/lang/en.json": 1462,
	"./routes/Home/Salary/SalaryItems/lang/fa.json": 1463,
	"./routes/Home/Salary/WritsSalary/lang/en.json": 1464,
	"./routes/Home/Salary/WritsSalary/lang/fa.json": 1465,
	"./routes/Home/Settings/lang/en.json": 1466,
	"./routes/Home/Settings/lang/fa.json": 1467,
	"./routes/Home/Sms/Definition/lang/en.json": 1468,
	"./routes/Home/Sms/Definition/lang/fa.json": 1469,
	"./routes/Home/Test/Import/lang/en.json": 1470,
	"./routes/Home/Test/Import/lang/fa.json": 1471,
	"./routes/Home/Test/Laboratory/lang/en.json": 1472,
	"./routes/Home/Test/Laboratory/lang/fa.json": 1473,
	"./routes/Home/Test/Storage/lang/en.json": 1474,
	"./routes/Home/Test/Storage/lang/fa.json": 1475,
	"./routes/Home/lang/en.json": 1476,
	"./routes/Home/lang/fa.json": 1477,
	"./routes/lang/en.json": 1478,
	"./routes/lang/fa.json": 1479
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1317;